import { Role } from '@/core/collections/modules/roles/role.interface';
import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';

export interface RoleServiceInterface {
   getRoles(moduleId: number, userId: number): Promise<ApiResource<Role>>;
}

export class RoleService implements RoleServiceInterface {
   async getRoles(moduleId: number, userId: number): Promise<ApiResource<Role>> {
      return await http.get<ApiResource<Role>>(`/modules/${moduleId}/users/${userId}/roles`).then((response) => response.data);
   }
}
